var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-card"},[_c('div',{staticClass:"header"},[_vm._v("\n        "+_vm._s(_setup.props.title)+"\n    ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }